var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"type":"danger","icon":"el-icon-delete","disabled":!_vm.processPackage || !_vm.permissions.includes('delete-package'),"circle":""},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }